<div
  class="min-w-64 rounded-xl border-4 bg-white p-4 text-center text-8xl font-extrabold text-emerald-500 transition-colors"
  [class]="{
    'border-surface-300': appearance() === 'DEFAULT',
    'border-red-500': appearance() === 'INCORRECT',
    'border-emerald-500': appearance() === 'CORRECT',
  }"
>
  {{ rule() }}
</div>
